import React from 'react'
import { colors } from '../../styles'
import styled from 'react-emotion'

const Message = styled('div')`  
  display: flex;
  margin: ${props => props.margin} 0 5px 0;    
  background-color: ${colors.error_bg};  
  :first {
    margin-top: 15px;
  }
  >div:first-child {
    flex-basis: 25%;    
  }
  >div:nth-child(2) {
    flex-basis: 5%;
  }
`

const Head = styled('div')`  
  border-bottom: 1px solid #fec3c3;
  padding: 5px 0 2px 0;
  display: flex;  
  background-color: ${colors.error_bg};
  >div:first-child {
    flex-basis: 25%;
  }
  >div:nth-child(2) {
    flex-basis: 5%;
  }
  div:last-child {
    margin-left: auto;
    font-weight: bold;
  }
`

const MessageBox = styled('div')`
  border: 1px solid;
  margin: 10px;  
  padding: 15px;
  border-radius: 4px;
  background-color: ${colors.error_bg};
  border-color: ${colors.error_border};
`

export default ({ textErrors }) => {
  if (!textErrors)
    return null

  const mailBody = encodeURI(textErrors.map((message) => {
    return `${message.prop} = \n`
  }).join(''))

  return (
    <MessageBox>
      <Head>
        <div>
          <b>Prop</b>
        </div>
        <div>
          <b>Type</b>
        </div>
        <div>
          <b>In Swedish</b>
        </div>
        <div>
          <a href={`mailto:team.customer@tui.se?subject=översättningar&body=${mailBody}`}>Create mail</a>
        </div>
      </Head>
      {textErrors.map((message, index) => (
        <Message key={index} margin={index === 0 ? "10px" : "5px"}>
          <div>
            <b>[{message.prop}]</b>
          </div>
          <div>
            {message.empty ? "empty" : "missing"}
          </div>
          <div>
            <b>{message.seText}</b>
          </div>
        </Message>
      ))}
    </MessageBox>
  )
}

